module.exports = __webpack_public_path__ + "img/Oval(2)_個人星盤.8fed15a9.svg";